import React from 'react';
import { toFormName } from '../../util/util';
import { SelectListItem } from '../../model/SelectListItem';

interface IFormTextItemProps{
    label:string;
    name?:string;
    value:string|number|null;
    items: SelectListItem[];
    onChange:(e:any)=>void;
    disabled?:boolean;
    placeholder?:string;
    helperText?:string;
    className?:string;
    required?:boolean;
    children?:string|React.ReactElement|undefined|boolean
}
const FormSelectItem = (props:IFormTextItemProps) => {
    const name = props.name || toFormName(props.label);
    return (
    
        <div className={ "form-item " + (props.className||'')}>
            <div>
            <label htmlFor="">{props.label}</label>
            { props.helperText && <small style={{marginLeft:'10px'}}>{props.helperText}</small>}
            </div>
            {/* <TextInput value={props.value} name={name} onChange={props.onChange} disabled={props.disabled} placeholder={props.placeholder} required={props.required} /> */}

            <select 
                            value={props.value!} 
                            name={name!} 
                            onChange={props.onChange} 
                            disabled={props.disabled} >
                                
                                { props.items.map(item => <option key={item.value} value={item.value}>{item.text}</option>)}
                                                                
                            </select>


            { props.children }
        </div>
    )
}


export default FormSelectItem;